export enum ChargeType {
    Manual = 'manual',
    Automatic = 'automatic',
    Log = 'log',
    MarkedAsPaid = 'marked-as-paid',
}
